import { ActionKeys } from './constants';

export interface GTMEventPayload {
  eventName: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  data?: object;
}

export function sendGTMEvent(payload: GTMEventPayload) {
  return <const>{
    payload,
    type: ActionKeys.SEND_GTM_EVENT,
  };
}

export function sendGTMEventSuccess(eventName: string) {
  return <const>{
    eventName,
    type: ActionKeys.SEND_GTM_EVENT_SUCCESS,
  };
}

export function sendGTMEventError(eventName: string, error: string) {
  return <const>{
    eventName,
    error,
    type: ActionKeys.SEND_GTM_EVENT_ERROR,
  };
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function pushToGTMDataLayer(payload: object) {
  return <const>{
    payload,
    type: ActionKeys.PUSH_TO_GTM_DATA_LAYER,
  };
}

export function pushToGTMDataLayerSuccess() {
  return <const>{
    type: ActionKeys.PUSH_TO_GTM_DATA_LAYER_SUCCESS,
  };
}

export function pushToGTMDataLayerError(errorMessage: string) {
  return <const>{
    errorMessage,
    type: ActionKeys.PUSH_TO_GTM_DATA_LAYER_ERROR,
  };
}

export type GTMActions =
  | ReturnType<typeof sendGTMEvent>
  | ReturnType<typeof sendGTMEventSuccess>
  | ReturnType<typeof sendGTMEventError>
  | ReturnType<typeof pushToGTMDataLayer>
  | ReturnType<typeof pushToGTMDataLayerSuccess>
  | ReturnType<typeof pushToGTMDataLayerError>;
